import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { ARTICLES } from '../constants'

const deleteArticle = async (id: number) => {
  await fetchAPI({
    path: `/articles/${id}`,
    method: 'delete',
  })
}

export const useDeleteArticle = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteArticle, {
    async onSuccess() {
      await queryClient.refetchQueries([ARTICLES])

      toast({
        description: t('views.admin.articles.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
